import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Home from './views/home'
import ProductsTea from './views/products-tea'
import ProductsSpritz from './views/products-spritz'
import Contact from './views/contact'
import ProductsSoap from './views/products-soap'
import ProductsBody from './views/products-body'
import Products from './views/products'
import NotFound from './views/not-found'
import './style.css'

Vue.use(Router)
Vue.use(Meta)
export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Home',
      path: '/',
      component: Home,
    },
    {
      name: 'Products-Tea',
      path: '/products-tea',
      component: ProductsTea,
    },
    {
      name: 'Products-Spritz',
      path: '/products-spritz',
      component: ProductsSpritz,
    },
    {
      name: 'Contact',
      path: '/contact',
      component: Contact,
    },
    {
      name: 'Products-Soap',
      path: '/products-soap',
      component: ProductsSoap,
    },
    {
      name: 'Products-Body',
      path: '/products-body',
      component: ProductsBody,
    },
    {
      name: 'Products',
      path: '/products',
      component: Products,
    },
    {
      name: '404 - Not Found',
      path: '**',
      component: NotFound,
      fallback: true,
    },
  ],
})
